import React, { useState } from "react";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router";

// @material-ui/core components
import { withStyles } from "tss-react/mui";
import { FormControl, GridLegacy, Link as Link2, Select } from "@mui/material";

// material-ui icons
import { Add, ConfirmationNumber, Queue } from "@mui/icons-material";

import VestigingenFilter, { getVestigingFilterState } from "../../components/VestigingFilter/VestigingFilter";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import JamezzTable from "../../components/JamezzTable/JamezzTable";
import Button from "../../components/CustomButtons/Button";

import tafelStyle from "../../assets/jss/material-dashboard-pro-react/views/tafelStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";
import { convertArrayToSelectOptions } from "../../templateHelpers";
import * as actions from "../../store/actions";

//Modals
import AddUniqueVouchers from "./Modals/AddUniqueVouchers";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import AuthenticationWrapper from "../../auth/AuthenticationWrapper";
import FormTextTC from "../../components/Forms/FormTextTC";
import { useWatch } from "react-hook-form";
import FormSwitchTC from "../../components/Forms/FormSwitchTC";
import FormAsyncTC from "../../components/Forms/FormAsyncTC";
import FormV2 from "../JamezzForm/FormV2";
import CardIcon from "../../components/Card/CardIcon";
import CardHeader from "../../components/Card/CardHeader";
import Card from "../../components/Card/Card";
import CardBody from "../../components/Card/CardBody";

class Index extends React.Component {
  state = {
    addUniqueVouchersModal: false,
    selectedIds: [],

    showDeleteAlert: false,
  };

  jamezzTable = React.createRef();

  componentWillUnmount() {
    /**
     * Current request annuleren bij snel klikken kan zijn dat die nog niet klaar is
     */
    if (this.currentReqeust !== undefined) {
      this.currentReqeust.cancel();
    }
  }

  /**
   * Modal functions
   */
  toggleModal(modal) {
    let newState = { ...this.state };
    newState[modal] = !this.state[modal];
    this.setState(newState);
  }

  handleAddUniqueVouchersAction = (row) => {
    this.setState({
      selectedIds: [row[0]],
      addUniqueVouchersModal: true,
    });
  };

  render() {
    const { classes } = this.props;

    console.log(this.props.filters);

    const showActiveFilter = [
      {
        value: "ALL",
        label: getTranslation("voucherDefs.filters.setview.all", "Alle definities [~]"),
      },
      {
        value: "0",
        label: (
          <TranslationWrapper tDefault={"Alleen active definities [~]"} tKey={"voucherDefs.filters.setview.active"} />
        ),
      },
      {
        value: "1",
        label: (
          <TranslationWrapper
            tDefault={"Allen INactieve definities [~]"}
            tKey={"voucherDefs.filters.setview.non-active"}
          />
        ),
      },
    ];
    const showActiveOptions = convertArrayToSelectOptions(showActiveFilter, classes);

    let actions = [];
    actions.push({
      icon: Queue,
      tooltip: (
        <TranslationWrapper tDefault={"Add Unique Vouchers"} tKey={"voucherDefs.table.tooltip.addUniqueVouchers"} />
      ),
      action: this.handleAddUniqueVouchersAction,
    });

    return (
      <div>
        <MainNavbar
          paginaTitel={<TranslationWrapper tDefault={"Discount-Definitions"} tKey={"voucherDefs.pagetitle"} />}
        />

        <GridContainer>
          <GridItem xs={12}>
            {this.props.vestiging_id ? (
              <AuthenticationWrapper permissionKey={"voucherDefs.create"}>
                <Link to={"./create"}>
                  <Button className={classes.marginRight} color={"success"}>
                    <Add className={classes.icons} />{" "}
                    <TranslationWrapper tDefault={"Nieuwe kortings definitie"} tKey={"voucherDefs.nieuw.item"} />
                  </Button>
                </Link>
              </AuthenticationWrapper>
            ) : null}
          </GridItem>
        </GridContainer>

        {/* Filters */}
        <GridContainer>
          {/* Sales Area Filter */}
          <VestigingenFilter />
          {/* Custom Filter: Dropdown: All/Active/Non-active  */}
          <GridItem sm={4} xs={12}>
            <FormControl className={classes.selectFormControl} fullWidth>
              <Select
                MenuProps={{
                  className: classes.selectMenu,
                }}
                classes={{
                  select: classes.select,
                }}
                inputProps={{
                  name: "simpleSelect",
                  id: "simple-select",
                  style: { paddingTop: "32px" },
                }}
                onChange={(e) => {
                  switch (e.target.value) {
                    case "ALL":
                      this.props.setFilter("vouchersDefs:active", null);
                      break;
                    case "0":
                      this.props.setFilter("vouchersDefs:active", {
                        field: "active",
                        operator: "=",
                        value: 1,
                        selectValue: "0",
                      });
                      break;
                    case "1":
                      this.props.setFilter("vouchersDefs:active", {
                        field: "active",
                        operator: "=",
                        value: 0,
                        selectValue: "1",
                      });
                      break;
                  }
                }}
                value={this.props.filters["vouchersDefs:active"]?.selectValue ?? "ALL"}
              >
                {showActiveOptions}
              </Select>
            </FormControl>
          </GridItem>
        </GridContainer>

        {/*Extra voucher option inputs*/}
        {this.props.vestiging_id ? (
          <AuthenticationWrapper
            child={() => (
              <GridLegacy container xs={12}>
                <Card>
                  <CardHeader color={"primary"} icon>
                    <CardIcon color={"primary"}>
                      <ConfirmationNumber />
                    </CardIcon>
                    <h4 className={classes.cardIconTitle}>
                      <TranslationWrapper
                        tDefault={"Advanced voucher options"}
                        tKey={"voucherDefinitions.table.extraVoucherOptions"}
                      />
                    </h4>
                  </CardHeader>

                  <CardBody>
                    <FormV2
                      endPoint={"core/vestigingen"}
                      isSaveButtonSticky={false}
                      modelId={this.props.vestiging_id}
                      onGetModel={(model) => {
                        if (model.extra_settings) {
                          Object.keys(model.extra_settings).forEach((key) => {
                            model["extra_settings__" + key] = model.extra_settings[key];
                          });
                        }
                      }}
                      pageTitle={"Vestiging"}
                    >
                      <ExtraVoucherOptions />
                    </FormV2>
                  </CardBody>
                </Card>
              </GridLegacy>
            )}
            permissionKey={"voucherdefs.card.advancedVouchers"}
          />
        ) : null}

        <GridContainer>
          <GridItem xs={12}>
            <JamezzTable
              actions={actions}
              dataMapping={[
                { dbfield: "id", editable: false },
                { dbfield: "vestiging.naam", editable: false },
                { dbfield: "title", editable: true, inputtype: "Input" },
                { dbfield: "discountType", editable: false },
                { dbfield: "active", editable: true, inputtype: "Switch" },
                { dbfield: "blocked", editable: true, inputtype: "Switch" },
                { dbfield: "usedCounter", editable: false },
              ]}
              delete={"voucherDefs.delete"}
              editLink={"./:id/edit"}
              editLinkPermission={"voucherDefs/:id/edit"}
              fetchUrl={"core/voucherdefs"}
              filters={this.props.filters}
              headerIcon={<ConfirmationNumber />}
              headers={[
                {
                  label: getTranslation("voucherDefs.table.id", "#"),
                  sortable: true,
                  sortKey: "id",
                },
                {
                  label: getTranslation("voucherDefs.table.verkoopgebied", "Verkoopgebied"),
                  sortable: true,
                  sortKey: "vestiging.naam",
                },
                {
                  label: getTranslation("voucherDefs.table.title", "Titel"),
                  sortable: true,
                  sortKey: "title",
                },
                {
                  label: getTranslation("voucherDefs.table.discountType", "Type"),
                  sortable: true,
                  sortKey: "discountType",
                },
                {
                  label: getTranslation("voucherDefs.table.active", "Actief"),
                  sortable: true,
                  sortKey: "active",
                },
                {
                  label: getTranslation("voucherDefs.table.blocked", "Geblokkeerd"),
                  sortable: true,
                  sortKey: "blocked",
                },
                {
                  label: getTranslation("voucherDefs.table.usedCounter", "#Gebruikt"),
                  sortable: true,
                  sortKey: "usedCounter",
                },
              ]}
              reduxKey={"voucherDefs"}
              ref={this.jamezzTable}
              tableTitle={<TranslationWrapper tDefault={"Korting Definities"} tKey={"voucherDefs.table.titel"} />}
            />
          </GridItem>
        </GridContainer>

        {/*MODAL POPUPS*/}
        <AddUniqueVouchers
          open={this.state.addUniqueVouchersModal}
          refreshTable={() => this.jamezzTable.current?.getData()}
          toggle={() => this.toggleModal("addUniqueVouchersModal")}
          voucherDefIds={this.state.selectedIds}
        />
      </div>
    );
  }
}

Index.propTypes = {
  classes: PropTypes.object,
};

//REDUX
const mapStateToProps = (state) => {
  let filters = getVestigingFilterState(state, true);
  if (state.filtersV2["vouchersDefs:active"]) {
    filters["vouchersDefs:active"] = state.filtersV2["vouchersDefs:active"];
  }
  return {
    filters,
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setFilter: (key, filter) => {
      dispatch({
        type: actions.SET_FILTER,
        payload: { key, filter },
      });
    },
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
  };
};

function ExtraVoucherOptions() {
  const extra_settings__enableVoucherMasterVestigingValue = useWatch({
    name: "extra_settings__enableVoucherMasterVestiging",
  });

  const extra_settings__autoDiscountValue = useWatch({
    name: "extra_settings__autoDiscount",
  });

  //Take value from useWatch value only when component is rendered
  const [startValue_extra_settings__autoDiscountValue, setStartValue_extra_settings__autoDiscountValue] = useState(
    extra_settings__autoDiscountValue
  );

  const [showExtraOptions, setShowExtraOptions] = useState(false);

  return (
    <>
      <Card>
        <FormSwitchTC
          name={"extra_settings__enableVoucherMasterVestiging"}
          tDefault={"Voucher Master Salesarea (enable)"}
          tKey={"vestigingen.form.overige.label.extra_settings__enableVoucherMasterVestiging"}
        />
        {extra_settings__enableVoucherMasterVestigingValue ? (
          <FormAsyncTC
            async={{
              url: "core/vestigingen/search?fields=id as value, systeemNaam as label&per_page=50",
              searchField: "systeemNaam",
            }}
            name={"extra_settings__voucherMasterVestiging_id"}
            nullable={true}
            tDefault={"Voucher Master Salesarea (id)"}
            tKey={"vestigingen.form.overige.label.extra_settings__voucherMasterVestiging_id"}
          />
        ) : null}
      </Card>
      {showExtraOptions || startValue_extra_settings__autoDiscountValue ? (
        <Card>
          <FormTextTC
            name={"extra_settings__autoDiscount"}
            tDefault={"Auto discount"}
            tKey={"vestigingen.form.overige.label.autoDiscount"}
          />
        </Card>
      ) : null}
      {!showExtraOptions && !startValue_extra_settings__autoDiscountValue ? (
        <Link2
          component={"button"}
          onClick={() => {
            setShowExtraOptions(!showExtraOptions);
          }}
          variant={"body2"}
        >
          {getTranslation("voucherDefs.advancedOptions.showMoreOptions", "Show more options")}
        </Link2>
      ) : null}
    </>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(Index, tafelStyle));
